// extracted by mini-css-extract-plugin
export default {"btn":"JobApplicationsRow_btn__FdpN0","tr":"JobApplicationsRow_tr__BD4AQ","table-number-cell":"JobApplicationsRow_table-number-cell__A5cBC"};